<!-- 使用方法参考 appcenter/consume/pos/center.vue 顶部操作栏 -->
<template>
  <div class="auth_box">
    <!--suppress JSUnresolvedVariable -->
    <button class="-button" @click="getList"
    ><i class="el-icon-plus margin-right-4"></i>{{value}}</button>
    <el-dialog
      title="添加授权"
      :visible.sync="showTip"
      width="792px">
      <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
        <el-tab-pane label="住户授权" name="first" class="el_tab_item">
          <auth-tree ref="red" class="filter-tree" :update="treeUpdate"  />
        </el-tab-pane>
        <el-tab-pane label="人员授权" name="second">
          <!--远程搜索-->
          <el-input placeholder="姓名/手机号/所属住户" v-model="requestBody.searchKey" class="input-with-select" @keyup.13.native="getBasicPersonPage" size="small" style="margin-bottom: 10px;">
            <el-button slot="append" icon="el-icon-search" @click="getBasicPersonPage" size="small" />
          </el-input>
          <el-table
            ref="authPersonTable"
            :data="authPersonData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="75px">
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名">
            </el-table-column>
            <el-table-column
              prop="phone"
              label="手机号">
            </el-table-column>
            <el-table-column
              prop="enterpriseName"
              label="所属住户">
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination background layout="total, prev, pager, next, jumper"
                           @current-change="handleCurrentChange" :total="total">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAthority">取 消</el-button>
        <el-button type="primary" @click="addAthority">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {api} from '../../../view/api/access-ctrl'
  import AuthTree from '../auth-tree'
  import {nTipFunc, nWarn} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {AuthTree},
    name: 'button-auth',
    props: {
      value: {
        type: String,
        default: '添加'
      },
      onthis: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        requestBody: {
          pageNum: 1,
          pageSize: 10,
          searchKey: ''
        },
        total: 0,
        activeName2: 'first',
        authPersonData: [],
        showTip: false,
        props1: {
          label: 'name',
          children: 'zones',
          isLeaf: 'leaf'
        },
        treeUpdate: {
          render: () => {
            return api.getEnterpriseList()
              .then(list => {
                list.forEach(tree => {
                  tree._label = tree.enterpriseName
                })
                return list
              })
          }
        },
        personAuth: false,
        departmentAuth: true,
        adsStr: ''
      }
    },
    created () {
      this.getBasicPersonPage()
    },
    methods: {
      handleClick (tab) {
        if (tab.index === '0') {
          this.personAuth = false
          this.departmentAuth = true
        } else {
          this.personAuth = true
          this.departmentAuth = false
        }
      },
      getBasicPersonPage () {
        api.getBasicPersonPage(this.requestBody)
          .then((data) => {
            this.total = data.total
            this.authPersonData = data.list
          })
      },
      getList () {
        let deviceId = window.sessionStorage.getItem('devType')
        if (!deviceId) {
          nWarn('请先选择需要绑定的设备')
          return
        }
        let scenceCode = window.sessionStorage.getItem('scenceCode')
        if (scenceCode === '1') {
          nWarn('公共场景设备无须授权')
          return
        }
        // else if (scenceCode === '2') {
        //   nWarn('公寓场景设备无须授权')
        //   return
        // }
        this.showTip = true
      },
      cancelAthority () {
        this.showTip = false
        this.$refs.red._self.$refs.tree.setCheckedNodes([])
      },
      addAthority () {
        let deviceId = window.sessionStorage.getItem('devType')
        let deviceUse = window.sessionStorage.getItem('deviceUse')
        if (this.departmentAuth) {
          let depStr = window.sessionStorage.getItem('changeAuthDep')
          let data = {}
          data.deviceCode = deviceId
          data.deviceUse = deviceUse
          data.enterpriseCodes = depStr.split(',')
          console.log(data)
          api.addAthority(data)
            .then(
              nTipFunc('绑定成功')
            )
            .then(() => {
              this.showTip = false
              this.onthis.getData()
            })
            .catch(errorHandler('请求失败'))
        } else if (this.personAuth) {
          let data = {}
          data.personCodes = this.adsStr.split(',')
          data.deviceCode = deviceId
          data.deviceUse = deviceUse
          console.log(data)
          api.addAthority(data)
            .then(
              nTipFunc('绑定成功')
            )
            .then(() => {
              this.showTip = false
              this.onthis.getData()
            })
            .catch(errorHandler('请求失败'))
        }
        setTimeout(() => {
          this.$refs.red._self.$refs.authTree.setCheckedKeys([])
          this.showTip = false
        }, 50)
      },
      handleSelectionChange (val) {
        let adsArr = []
        val.map(v => {
          adsArr.push(v.code)
        })
        this.adsStr = adsArr.join(',')
      },
      handleCurrentChange (val) {
        this.requestBody.pageNum = val
        this.getBasicPersonPage()
      }
    }
  }
</script>

<style lang="less">
  @import "../styles/fun_var";

  .auth_box {
    .-button {
      min-width: 90px;
      .generate-common-button(#1362FF)
    }
    .el-input-group__append {
      padding: 0;
    }
    .el-input-group__append button.el-button {
      width: 100% !important;
      height: 30px!important;
      margin: 0;
      box-sizing: border-box;
    }

    .el-tabs--card > .el-tabs__header .el-tabs__item:first-child {
      width: 50%;
    }
    .el-tabs--card>.el-tabs__header .el-tabs__nav {
      display: flex;
    }
    .el-tabs--top.el-tabs--card .el-tabs__item:last-child {
      width: 50%!important;
      margin: 0;
    }
    .el-dialog .el-dialog__body table {
      width: 100%!important;
    }
    .el-dialog .el-dialog__body .el-table__empty-block {
      width: 100%;
    }
    .el-dialog .el-dialog__body .el-table th:first-child {
      width: 10%;
    }
    .el-dialog .el-dialog__body .el-table td, .el-dialog .el-dialog__body .el-table th {
      padding: 3px 0;
    }
    .el-dialog .el-dialog__body .el-table th .cell {
      text-align: center;
      color: #333333;
    }
    .el-dialog .page {
      margin-top: 20px;
      position: relative;
      bottom: 0;
    }
    .el-dialog .el-dialog__body {
      padding: 10px 20px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/buttons/button-auth.vue